
import { mapActions, mapGetters } from "vuex";
import { validationMixin } from "vuelidate";
import { SistemaMixin, ValidacaoMixin } from "@/modules/Application";
import { mask } from "vue-the-mask";

export default {
  name: "app-orcamento-timeline",
  mixins: [validationMixin, SistemaMixin, ValidacaoMixin],
  directives: {
    mask,
  },
  components: {},
  data() {
    return {
      timelineItems: [],
      cliente: null,
      orcamento: null,
    };
  },
  watch: {},
  computed: {
    ...mapGetters(["pageTitle", "layoutConfig"]),
  },
  methods: {
    ...mapActions(["setLoading"]),
    goBackToOrcamentoList() {
      this.$router.push({ name: "orcamento" });
    },
    async getInit() {
      const { id_orcamento } = this.$route.params;
      this.$http
        .post("/orcamento/timeline", {
          id_orcamento,
        })
        .then(({ data }) => {
          const timeline = data.timeline;
          this.cliente = data.cliente;
          this.orcamento = data.orcamento;
          timeline.dataAlteracao &&
            this.timelineItems.push({
              name: "Resposta do cliente",
              label: "Respondido",
              color: "turquoise",
              date: timeline.dataAlteracao.split(" ")[0],
              time: timeline.dataAlteracao.split(" ")[1],
              contato: timeline.contato,
              observacao: timeline.observacaoCliente,
              status: timeline.status,
            });
          timeline.dataEnvioLink &&
            this.timelineItems.push({
              name: "Envio de link",
              label: "Enviado",
              color: "green",
              date: timeline.dataEnvioLink.split(" ")[0],
              time: timeline.dataEnvioLink.split(" ")[1],
            });
          timeline.dataVisualizacao &&
            this.timelineItems.push({
              name: "Visualização",
              label: "Cliente visualizou",
              color: "orange",
              date: timeline.dataVisualizacao.split(" ")[0],
              time: timeline.dataVisualizacao.split(" ")[1],
            });
          this.timelineItems.sort((a, b) => {
            if (a.date === b.date) {
              return a.time < b.time ? -1 : 1;
            } else {
              return a.date < b.date ? -1 : 1;
            }
          });
          this.setLoading(false);
        })
        .catch((error) => {
          this.setLoading(false);
          this.$toast.error(`Erro ao buscar orçamento:\n${error}`);
        });
    },
  },
  async created() {
    this.setLoading(true);
    this.getInit();
  },
};
